/*
 * Клиент биллинга.
 *
 * Адрес приходит из <meta name="billing-api">, чтобы один и тот же бандл
 * работал на локальной машине, на стейдже и на проде.
 */

const FALLBACK_ORIGIN = "https://billing-back.shamcrm.com";

function origin() {
    const meta = document.querySelector('meta[name="billing-api"]');
    const value = (meta?.content || "").trim();

    return (value || FALLBACK_ORIGIN).replace(/\/+$/, "");
}

export const billing = {
    emailCheck: (email) =>
        `${origin()}/api/v2/demo/email-check?email=${encodeURIComponent(email)}`,
    demoRequests: () => `${origin()}/api/v2/demo/requests`,
    demoRequest: (uuid) =>
        `${origin()}/api/v2/demo/requests/${encodeURIComponent(uuid)}`,
    legacyLead: () => `${origin()}/api/sendRequest`,
};

/**
 * Запрос к API. Ошибку сети превращаем в исключение, а ответ с любым кодом —
 * в объект: у вызывающего кода это две разные ситуации.
 *
 * @returns {Promise<{ok: boolean, status: number, data: object}>}
 */
export async function requestJson(url, options = {}) {
    const response = await fetch(url, {
        ...options,
        headers: {
            Accept: "application/json",
            ...(options.body ? { "Content-Type": "application/json" } : {}),
            ...(options.headers || {}),
        },
    });

    const data = await response.json().catch(() => ({}));

    return { ok: response.ok, status: response.status, data };
}
